import { isNotBlank } from "./CommonServices";
import { AuthUser } from "./Types";

export const isLoggedIn = (authUser?: AuthUser): boolean => {
    return authUser !== undefined
        && isNotBlank(authUser.email)
        && isNotBlank(authUser.sessionToken);
}